import Api from 'services/AirBaltic/Api'
import get from 'lodash-es/get'

class Destinations {
  convertData (response) {
    return get(response, 'data', [])
  }

  getHistogramData (originCode, destinCode) {
    return new Api().get(`/2e/offers/${originCode}/${destinCode}`)
      .then(response => Promise.resolve(this.convertData(response)))
      .catch(error => Promise.reject(error))
  }
}

export default Destinations
